import DialogContainer from "../../components/common/DialogContainer";
import { Outlet, useLocation } from "react-router-dom";
import Cookies from "../../components/common/Cookies";
import { useEffect, useRef, useState } from "react";
import Toaster from "../../components/ui/Toaster";
import Sidebar from "../common/Sidebar";
import Footer from "../common/Footer";
import Header from "../common/Header";
import { Box } from "@mui/material";
import { SOCKET_BASEURI } from "../../utils/helper";
import { io } from "socket.io-client";
import { setSocket } from "../../redux/user-slices/socket.slice";
import { useDispatch } from "react-redux";
import { handleGetMySubscription } from "../../redux/member-slices/payment.slice";
import { setSubscription } from "../../redux/user-slices/subscription.slice";
import { useFirebaseNotifications } from "../../hooks/useFirebaseNotifications";

function Layout() {
  useFirebaseNotifications();
  const socket = useRef(null);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [active, setActive] = useState(false);

  const sidebarActive = () => {
    setActive(true);
  };
  const sidebarDeActive = () => {
    setActive(false);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    socket.current = io.connect(SOCKET_BASEURI);
    if (!socket.current) return;
    dispatch(setSocket(socket.current));
    // eslint-disable-next-line
  }, [socket.current]);


  
    useEffect(() => {
      const loadSubscription = async () => {
        const response = await dispatch(
          handleGetMySubscription() 
        );
  
        if (response?.payload) {
          dispatch(
            setSubscription(response.payload)
          );
        }
      };
  
      loadSubscription();
    }, []);

  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        minHeight: "100vh",
        overflowX: "hidden",
        maxWidth: "100vw",
        gridTemplateRows: "auto auto 1fr",
      }}
    >
      <Sidebar active={active} sidebarDeActive={sidebarDeActive} />
      <Header sidebarActive={sidebarActive} />

      <Box
        component="main"
        sx={{
          width: "100%",
          maxWidth: "100vw",
          overflowX: "hidden",
        }}
      >
        <Outlet context={{ active }} />
      </Box>
      <Footer />
      <Toaster />
      <DialogContainer />
      <Cookies />
    </Box>
  );
}

export default Layout;
